import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    permissions: [],
    groupPermissions: [],
    activeGroupPermissionsMap: {},
    activePermissionsMap: {},
    permissionsPilkiPro: [],
    groupPermissionsPilkiPro: [],
    activeGroupPermissionsMapPilkiPro: {},
    activePermissionsMapPilkiPro: {},
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
